import * as chains from 'viem/chains'
import { hyperliquid, katana, megaEth, plasma, robinhood } from './customChains'

const excludedChains = ['Wanchain Testnet', 'Zora Goerli Testnet', 'HyperEVM', 'MegaETH']

const filterChainsByName = <T extends Record<string, { name: string }>>(allChains: T, excludedNames: string[]): T => {
  return Object.fromEntries(Object.entries(allChains).filter(([_, chain]) => !excludedNames.includes(chain.name))) as T
}

const filteredChains = filterChainsByName(chains, excludedChains)

export const viemChains = { ...filteredChains, hyperliquid, plasma, katana, ['mega-eth']: megaEth, robinhood }
export type ViemChain = (typeof viemChains)[keyof typeof viemChains]
